import { render, staticRenderFns } from "./Selecione.vue?vue&type=template&id=3337c8f1&scoped=true"
import script from "./Selecione.vue?vue&type=script&lang=js"
export * from "./Selecione.vue?vue&type=script&lang=js"
import style0 from "./Selecione.vue?vue&type=style&index=0&id=3337c8f1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3337c8f1",
  null
  
)

export default component.exports